import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { BEARER_ONLY } from '../interceptor/token.interceptor';
import { DatePipe } from '@angular/common';
// import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})
export class QRCodeService {

  constructor(
    private http: HttpClient,
    private datePipe: DatePipe
  ) { }

  generate(simValue) {
    return new Promise((resolve, reject) => {
        this.http.post(environment.apiUrl + '/v2/qrcode/generate', {simValue}, { context: new HttpContext().set(BEARER_ONLY, true) })
        .pipe(timeout(30000))
        .subscribe(
            response => {
                console.log('GET call in success', response);
                resolve(response);
            },
            error => {
                console.log('GET call in error', error);
                reject(error);
            },
        );
    });
  }

  processOrgPoinstQR(points, userProfile, carrierName) {
    return new Promise((resolve, reject) => {
      const dateNow = this.datePipe.transform(new Date(), 'YYYYMMdd');
      const userId = 999999999 - userProfile.id;

      let qrs = [{
        type: 'Points',
        value: points.getPoints,
        qr: `0-${dateNow}-${userId}-1-${carrierName}`,
        // qr: `${userId}|${dateNow}$1#0|1~0#0$${carrierName}#|${1}`,
        qty: 1
      }];

      for (let i=2; i<6; i++) {
        qrs.push({
          type: 'Points',
          value: points.getPoints,
          qr: `0-${dateNow}-${userId}-${i}-${carrierName}`,
          // qr: `${userId}|${dateNow}$1#0|${i}~0#0$${carrierName}#|${1}`,
          qty: i
        })
      }

      resolve(qrs);
    });
  }
  
  processOrgPassQR(pass, userProfile, carrierName) {
    return new Promise((resolve, reject) => {
      //Get current timestamps
      const currDateTime = new Date().getTime();
  
      //Current Date
      const dateNow = this.datePipe.transform(new Date(), 'YYYYMMdd');
    
      //Get Expiration Date
      // const expDate = (pass.status == 'new') ? pass.deadline : pass.expiresOn;
      // const expTimestamp = new Date(expDate).getTime();

      const expDateTimeStamp = (pass.status == 'active') ? new Date(pass.expiresOn).getTime() : 0;
      const deadlineTimeStamp = (pass.status == 'new') ? new Date(pass.deadline).getTime() : 0;
      const userId = 999999999 - userProfile.id;
  
      //Encrypt QR Code
      const encryptedPassQr = {
        type: 'Pass',
        value: pass.passName,
        qr: `1-${dateNow}-${userId}-${pass.passId}-${pass.userPassesId}-${expDateTimeStamp}-${deadlineTimeStamp}`,
        // qr: `${userId}|${dateNow}$0#${isExpired}|1~${pass.passId}#${pass.userPassesId}$${carrierName}#|${1}`,
        qty: 1,
        expiresOn: (pass.status == 'new') ? deadlineTimeStamp : expDateTimeStamp,
        isActivated: (pass.status == 'new') ? false : true
      }

      resolve(encryptedPassQr);
    });
  }

  processEventQr(event, userProfile, carrierName) {
    return new Promise((resolve, reject) => {
      //Get current timestamps
      const currDateTime = new Date().getTime();
  
      //Current Date
      const dateNow = this.datePipe.transform(new Date(), 'YYYYMMdd');
    
      //Get Expiration Date
      const expDate = event?.eventDate;
      const expTimestamp = new Date(expDate).getTime();
      const isExpired = (expTimestamp > currDateTime) ? 0 : 1;
      const userId = 999999999 - userProfile.id;
  
      //Encrypt QR Code
      const encryptedPassQr = {
        type: 'Event',
        value: event.eventName,
        qr: `4-${dateNow}-${userId}-${expTimestamp}`,
        // qr: `${userId}|${dateNow}$2#${isExpired}|1~${''}#${''}$${carrierName}`,
        qty: 1
      }

      resolve(encryptedPassQr);
    });
  }

  processAppointmentQr(appointment, userProfile, carrierName) {
    return new Promise((resolve, reject) => {
      //Get current timestamps
      const currDateTime = new Date().getTime();
  
      //Current Date
      const dateNow = this.datePipe.transform(new Date(), 'YYYYMMdd');
    
      //Get Expiration Date
      const expDate = appointment?.expiresOn;
      const expTimestamp = new Date(expDate).getTime();
      const isExpired = (expTimestamp > currDateTime) ? 0 : 1;
      const userId = 999999999 - userProfile.id;
  
      //Encrypt QR Code
      const encryptedPassQr = {
        type: 'Event',
        value: appointment.organizationName,
        qr: `5-${dateNow}-${userId}-${carrierName}`,
        // qr: `${userId}|${dateNow}$2#${isExpired}|1~${''}#${''}$${carrierName}`,
        qty: 1
      }

      resolve(encryptedPassQr);
    });
  }
}
